import { IMasterDataAdapter } from './IMasterDataAdapter';
import { ApiResponse } from '../../types/api';
import { Plant, Building, Floor, Location, Department, Category, Subcategory, PriorityMaster, StatusMaster } from '../../types/masterData';
import { ApiClient } from '../apiClient';

export class LaravelMasterDataAdapter implements IMasterDataAdapter {
  async getPlants(): Promise<ApiResponse<Plant[]>> {
    return ApiClient.get<Plant[]>('/api/v1/master/plants');
  }

  async getBuildings(plantId?: string): Promise<ApiResponse<Building[]>> {
    return ApiClient.get<Building[]>(`/api/v1/master/buildings?plant_id=${plantId || ''}`);
  }

  async getFloors(buildingId?: string): Promise<ApiResponse<Floor[]>> {
    return ApiClient.get<Floor[]>(`/api/v1/master/floors?building_id=${buildingId || ''}`);
  }

  async getLocations(floorId?: string): Promise<ApiResponse<Location[]>> {
    return ApiClient.get<Location[]>(`/api/v1/master/locations?floor_id=${floorId || ''}`);
  }

  async getDepartments(): Promise<ApiResponse<Department[]>> {
    return ApiClient.get<Department[]>('/api/v1/master/departments');
  }

  async getCategories(): Promise<ApiResponse<Category[]>> {
    return ApiClient.get<Category[]>('/api/v1/master/categories');
  }

  async getSubcategories(categoryId?: string): Promise<ApiResponse<Subcategory[]>> {
    return ApiClient.get<Subcategory[]>(`/api/v1/master/subcategories?category_id=${categoryId || ''}`);
  }

  async getPriorities(): Promise<ApiResponse<PriorityMaster[]>> {
    return ApiClient.get<PriorityMaster[]>('/api/v1/master/priorities');
  }

  async getStatuses(): Promise<ApiResponse<StatusMaster[]>> {
    return ApiClient.get<StatusMaster[]>('/api/v1/master/statuses');
  }
}
